import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

// Libraries
import moment from "moment/moment";
import { Form, InputGroup } from "react-bootstrap";




export default function Index() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [orders, setOrders] = useState([]);

    const [submittedOrdersDate, setSubmittedOrdersDate] = useState(moment().format("YYYY-MM-DD"));
    const [agentDateFrom, setAgentDateFrom] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [agentDateTo, setAgentDateTo] = useState(moment().endOf("month").format("YYYY-MM-DD"));
    const [agents, setAgents] = useState([]);
    const [agent, setAgent] = useState("");

    const [supplierDateFrom, setSupplierDateFrom] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [supplierDateTo, setSupplierDateTo] = useState(moment().endOf("month").format("YYYY-MM-DD"));
    const [suppliers, setSuppliers] = useState([]);
    const [supplier, setSupplier] = useState("");   

    const [allOrdersDateFrom, setAllOrdersDateFrom] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [allOrdersDateTo, setAllOrdersDateTo] = useState(moment().endOf("month").format("YYYY-MM-DD"));


    function submittedOrders() {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/reports/submittedordersbydate?date=${submittedOrdersDate}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `report.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    };

    function agentPerformanceOverview() {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/reports/contributionbyagentoverview?dateFrom=${agentDateFrom}&dateTo=${agentDateTo}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `report.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    };

    function agentPerformance() {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/reports/contributionbyagent?agentId=${agent}&dateFrom=${agentDateFrom}&dateTo=${agentDateTo}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `report.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    };

    function supplierPerformanceOverview() {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/reports/contributionbysupplieroverview?dateFrom=${supplierDateFrom}&dateTo=${supplierDateTo}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `report.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    };

    function supplierPerformance() {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/reports/contributionbysupplier?supplierId=${supplier}&dateFrom=${supplierDateFrom}&dateTo=${supplierDateTo}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `report.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    };

    function allOrders() {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/reports/allOrders?dateFrom=${allOrdersDateFrom}&dateTo=${allOrdersDateTo}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `report.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    };

    // On Load
    useEffect(() => {

        

        // Load Agents
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/users/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setAgents(res.data);
                }
            })

        // Load suppliers
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setSuppliers(res.data);
                }
            })

    }, [])



    return (
        <div className="page">
            <div className="row">



                
                <h1>Available Reports</h1>


                { /* Daily Report Of Submitted Orders */}
                <h3>Daily Report Of Submitted Orders</h3>
                    <div className="row">
                        <div className="col-6">
                            <input type="date" className="form-control" value={submittedOrdersDate} onChange={(e) => setSubmittedOrdersDate(e.target.value)} />
                        </div>
                        <div className="col-6">
                            <button className="btn btn-primary" onClick={submittedOrders}>Generate</button>
                        </div>
                    </div>

                <hr style={{ marginTop: 20 }} />

                { /* Agent Performance */}
                <h3 style={{marginTop:10} }>Agent Performance</h3>
                    <div className="row">

                        { /* Date - Greater Than */}
                        <div className="form-group col-3">
                            <label>Date</label>
                            <InputGroup>
                                <InputGroup.Text>After</InputGroup.Text>

                                <Form.Control
                                    required
                                    type="date"
                                    placeholder="e.g 25/12/2024"
                                    onChange={(e) => setAgentDateFrom(e.target.value)}
                                    value={agentDateFrom}
                                />
                            </InputGroup>
                        </div>

                        { /* Date - Less Than */}
                        <div className="form-group col-3">
                            <label>Date</label>
                            <InputGroup>
                                <InputGroup.Text>Before</InputGroup.Text>

                                <Form.Control
                                    required
                                    type="date"
                                    placeholder="e.g 25/12/2025"
                                    onChange={(e) => setAgentDateTo(e.target.value)}
                                    value={agentDateTo}
                                />
                            </InputGroup>
                        </div>      
                    </div>
                    <div className="row">
                        <div className="col-2">
                            <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={agentPerformanceOverview}>Generate Overview</button>
                        </div>
                        <div className="col-1">
                            <p style={{ marginTop: 20 }} >- OR -</p>
                        </div>
                        { /* Agents */}
                        <div className="form-group col-3">
                            <label>Agents</label>
                            <div className="select">
                                <Form.Select
                                    onChange={(e) => setAgent(e.target.value)}
                                    value={agent}
                            >
                                <option value="">-- Please Select --</option>
                                    {agents && (agents.map((agent) => {
                                        return <option key={agent.id} value={agent.id}>{agent.name}</option>
                                    }))}
                                </Form.Select>
                            </div>
                        </div>

                        <div className="col-6">
                            <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={agentPerformance} disabled={!agent}>Generate</button>
                        </div>
                    </div>

                <hr style={{marginTop:10} } />

                { /* Supplier Performance */}
                <h3 style={{ marginTop: 20 }}>Supplier Performance</h3>
                <div className="row">

                    { /* Date - Greater Than */}
                    <div className="form-group col-3">
                        <label>Date</label>
                        <InputGroup>
                            <InputGroup.Text>After</InputGroup.Text>

                            <Form.Control
                                required
                                type="date"
                                placeholder="e.g 25/12/2024"
                                onChange={(e) => setSupplierDateFrom(e.target.value)}
                                value={supplierDateFrom}
                            />
                        </InputGroup>
                    </div>

                    { /* Date - Less Than */}
                    <div className="form-group col-3">
                        <label>Date</label>
                        <InputGroup>
                            <InputGroup.Text>Before</InputGroup.Text>

                            <Form.Control
                                required
                                type="date"
                                placeholder="e.g 25/12/2025"
                                onChange={(e) => setSupplierDateTo(e.target.value)}
                                value={supplierDateTo}
                            />
                        </InputGroup>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2">
                        <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={supplierPerformanceOverview}>Generate Overview</button>
                    </div>
                    <div className="col-1">
                        <p style={{ marginTop: 20 }} >- OR -</p>
                    </div>
                    { /* Suppliers */}
                    <div className="form-group col-3">
                        <label>Suppliers</label>
                        <div className="select">
                            <Form.Select
                                onChange={(e) => setSupplier(e.target.value)}
                                value={supplier}
                            >
                                <option value="">-- Please Select --</option>
                                {suppliers && (suppliers.map((supplier) => {
                                    return <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                                }))}
                            </Form.Select>
                        </div>
                    </div>

                    <div className="col-6">
                        <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={supplierPerformance} disabled={!supplier}>Generate</button>
                    </div>
                </div>



                { /* All Orders */}
                <h3 style={{ marginTop: 20 }}>All Orders</h3>
                <div className="row">

                    { /* Date - Greater Than */}
                    <div className="form-group col-3">
                        <label>Date</label>
                        <InputGroup>
                            <InputGroup.Text>After</InputGroup.Text>

                            <Form.Control
                                required
                                type="date"
                                placeholder="e.g 25/12/2024"
                                onChange={(e) => setAllOrdersDateFrom(e.target.value)}
                                value={allOrdersDateFrom}
                            />
                        </InputGroup>
                    </div>

                    { /* Date - Less Than */}
                    <div className="form-group col-3">
                        <label>Date</label>
                        <InputGroup>
                            <InputGroup.Text>Before</InputGroup.Text>

                            <Form.Control
                                required
                                type="date"
                                placeholder="e.g 25/12/2025"
                                onChange={(e) => setAllOrdersDateTo(e.target.value)}
                                value={allOrdersDateTo}
                            />
                        </InputGroup>
                    </div>

                    <div className="col-6">
                        <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={allOrders} >Generate</button>
                    </div>
                </div>
                













                        
                       

                            
                    

            </div>
        </div>
    )
}
